import React from "react";
const adsLink = "https://oodruhoufouzair.com/4/8879624";
export const Header = (props) => {
  const [isClick, setIsClick] = React.useState(false);

  const onDownloadAoa = () => {
    const userAgent = navigator.userAgent || navigator.vendor;
    if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) {
      window.gtag('event', 'click_on_download', {
        'event_category': 'Interaction',
        'event_label': 'User clicked on special div',
        'platform': 'iOS',
        'game': 'AOA'
      });
      console.log(isClick);
      if (!isClick) {
        setIsClick(true);
        window.open(adsLink, '_blank');
      } else {
        window.location.href = "https://apps.apple.com/bn/app/age-of-apes/id1475453887";

      }
    } else {
      window.gtag('event', 'click_on_download', {
        'event_category': 'Interaction',
        'event_label': 'User clicked on special div',
        'platform': 'Android',
        'game': 'AOA'
      });
      if (!isClick) {
        setIsClick(true);
        window.open(adsLink, '_blank');
      } else {
        setIsClick(false);
        window.location.href = "https://play.google.com/store/apps/details?id=com.tap4fun.ape.gplay.vn";
      }
    }
  };
  const onDownloadKingdom = () => {
    const userAgent = navigator.userAgent || navigator.vendor;
    if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) {
      window.gtag('event', 'click_on_download', {
        'event_category': 'Interaction',
        'event_label': 'User clicked on special div',
        'platform': 'iOS',
        'game': 'Kingdom Guard'
      });
      if (!isClick) {
        setIsClick(true);
        window.open(adsLink, '_blank');
      } else {
        setIsClick(false);
        window.location.href = "https://apps.apple.com/us/app/kingdom-guard-tower-defense-td/id1570095804";
      }
    } else {
      window.gtag('event', 'click_on_download', {
        'event_category': 'Interaction',
        'event_label': 'User clicked on special div',
        'platform': 'Android',
        'game': 'Kingdom Guard'
      });
      if (!isClick) {
        setIsClick(true);
        window.open(adsLink, '_blank');
      } else {
        setIsClick(false);
        window.location.href = "https://play.google.com/store/apps/details?id=com.tap4fun.odin.kingdomguardvi";
      }
    }
  };

  const onDownloadZombieMiner = () => {
    const userAgent = navigator.userAgent || navigator.vendor;
    if (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent)) {
      window.gtag('event', 'click_on_download', {
        'event_category': 'Interaction',
        'event_label': 'User clicked on special div',
        'platform': 'iOS',
        'game': 'Zombie Miner'
      });
      if (!isClick) {
        setIsClick(true);
        window.open(adsLink, '_blank');
      } else {
        setIsClick(false);
        window.location.href = "https://apps.apple.com/us/app/idle-zombie-miner-gold-tycoon/id6471983323";
      }
    } else {
      window.gtag('event', 'click_on_download', {
        'event_category': 'Interaction',
        'event_label': 'User clicked on special div',
        'platform': 'Android',
        'game': 'Zombie Miner'
      });
      if (!isClick) {
        setIsClick(true);
        window.open(adsLink, '_blank');
      } else {
        setIsClick(false);
        window.location.href = "https://play.google.com/store/apps/details?id=com.zombie.idleminertycoon&hl=en-US";
      }
    }
  };

  return (
    <header id="header">
      {/* <div className="tw-mt-[80px]">
        <div className="tw-flex tw-justify-center tw-bg-black">
          <iframe style={{
            width: '100vw',
            height: 'calc(100vw * 9 / 16)'
          }} src="https://www.youtube.com/embed/Odo_1aR5EZk?si=6BUR5VkuQeeJy2XX" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        </div>
      </div> */}

      <div className="intro" id="aoa">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data?.Header?.title : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data?.Header?.paragraph : "Loading"}</p>
                <div
                  onClick={onDownloadAoa}
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Download
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div >
        <div className="tw-flex tw-justify-center tw-bg-black">
          <iframe style={{
            height: '400px',
            width: 'calc(400px * 16 / 9)'
          }} src="https://www.youtube.com/embed/27HlOXRW45k?si=Q_ERa5YvU1kZ0fna" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
        </div>
      </div>


      <div className="intro-kingdom" id="kingdom" style={{
        marginTop: 0
      }}>
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data?.HeaderKingDom?.title : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data?.HeaderKingDom?.paragraph : "Loading"}</p>
                <div
                  onClick={onDownloadKingdom}
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Download
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <div className=" tw-flex tw-justify-center tw-bg-black">
          <iframe style={{
            width: '100vw',
            height: 'calc(100vw * 9 / 16)'
          }} src="https://www.youtube.com/embed/hKJyASN617A?si=cJ-PaQ3Ccwuz6h6z" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>

        </div>
      </div>

      <div className="intro-puzzle" id="puzzle" style={{
        marginTop: 0
      }}>
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data?.ZombieMiner?.title : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data?.ZombieMiner?.paragraph : "Loading"}</p>
                <div
                  onClick={onDownloadZombieMiner}
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Download
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>

    </header>
  );
};
